import { ConversationItemParts, mailStore } from 'owa-mail-store';
import { action, select } from 'satcheljs/lib/legacy';

export interface SetIsPendingDeleteConversationItemPartsState {
    conversationItemParts: ConversationItemParts;
}

export default action('setIsPendingDeleteConversationItemParts')(
    select<SetIsPendingDeleteConversationItemPartsState>({
        conversationItemParts: (conversationId: string) =>
            mailStore.conversations.get(conversationId),
    })(function setIsPendingDeleteConversationItemParts(
        conversationId: string,
        isPendingDelete: boolean,
        state?: SetIsPendingDeleteConversationItemPartsState
    ) {
        const conversationItemParts = state.conversationItemParts;
        if (conversationItemParts) {
            conversationItemParts.isPendingDelete = isPendingDelete;
        }
    })
);
